/* Cajon lateral de carrito Omelva.
   - Intercepta los enlaces a /cart y los formularios de anadir al carrito.
   - Se repinta con la Section Rendering API, asi que todo lo que se ve (lineas, importes, contador) sale de la
     respuesta de Shopify; aqui no hay plantillas de HTML ni importes calculados a mano.
   - Talla y color van como propiedades de linea, una pareja por unidad.
   - window.omCajon = { abrir, cerrar, refrescar, aviso } para la ficha de la braguita. */
(function () {
  var cajon = document.querySelector('[data-omj]');
  if (!cajon) return;

  var velo = document.querySelector('[data-omj-velo]');
  var idSeccion = cajon.dataset.seccion;
  var ultimoFoco = null;

  /* ---------- abrir y cerrar ---------- */

  function abrir() {
    ultimoFoco = document.activeElement;
    cajon.classList.add('on');
    if (velo) velo.classList.add('on');
    cajon.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = cajon.querySelector('.omj-cerrar');
    if (f) f.focus({ preventScroll: true });
  }

  function cerrar() {
    cajon.classList.remove('on');
    if (velo) velo.classList.remove('on');
    cajon.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  }

  function aviso(texto) {
    var m = cajon.querySelector('[data-omj-mensaje]');
    if (!m) return;
    m.textContent = texto || '';
    m.hidden = !texto;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cajon.classList.contains('on')) cerrar();
  });
  if (velo) velo.addEventListener('click', cerrar);

  /* Enlaces al carrito: abren el cajon en vez de navegar. */
  document.addEventListener('click', function (e) {
    var cerrarBtn = e.target.closest('[data-omj-cerrar]');
    if (cerrarBtn) { e.preventDefault(); cerrar(); return; }

    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (a.hasAttribute('data-omj-ignorar')) return;
    if (/\/cart\/?($|\?)/.test(href) && !/\/cart\/(add|change|update|clear)/.test(href)) {
      e.preventDefault();
      refrescar().then(abrir);
    }
  });

  /* ---------- repintado ---------- */

  function refrescar() {
    return fetch('/?sections=' + encodeURIComponent(idSeccion), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var html = datos[idSeccion];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-omj-contenido]');
        var actual = cajon.querySelector('[data-omj-contenido]');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        revisarTodo();
      })
      .catch(function () {})
      .then(pintarContador);
  }

  /* Contador del cajon y burbuja del icono del carrito de la cabecera, con el dato de Shopify. */
  function pintarContador() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-omj-contador]').forEach(function (e) { e.textContent = c.item_count; });
      var icono = document.getElementById('cart-icon-bubble');
      if (!icono) return;
      var burbuja = icono.querySelector('.cart-count-bubble');
      if (!c.item_count) { if (burbuja) burbuja.remove(); return; }
      if (!burbuja) {
        burbuja = document.createElement('div');
        burbuja.className = 'cart-count-bubble';
        burbuja.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        icono.appendChild(burbuja);
      }
      var spans = burbuja.querySelectorAll('span');
      if (spans[0]) spans[0].textContent = c.item_count < 100 ? c.item_count : '';
      if (spans[1]) spans[1].textContent = c.item_count + (c.item_count === 1 ? ' artículo' : ' artículos');
    }).catch(function () {});
  }

  function pedir(url, cuerpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.description || 'HTTP ' + r.status); e.datos = d; throw e; }
        return d;
      });
    });
  }

  /* ---------- anadir al carrito desde cualquier formulario ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var boton = form.querySelector('[type="submit"]');
    if (boton) { if (boton.getAttribute('aria-busy') === 'true') return; boton.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) { var er = new Error(d.description || 'HTTP ' + r.status); er.datos = d; throw er; }
          return d;
        });
      })
      .then(function () { return refrescar(); })
      .then(function () { aviso(''); abrir(); })
      .catch(function (err) {
        /* No se reenvia el formulario a ciegas: podria duplicar lo que Shopify ya hubiera anadido. */
        return refrescar().then(function () {
          aviso((err && err.datos && err.datos.description) || 'No se ha podido añadir. Revisa tu conexión y vuelve a intentarlo.');
          abrir();
        });
      })
      .then(function () { if (boton) boton.removeAttribute('aria-busy'); });
  });

  /* ---------- lineas ---------- */

  function lineas() { return [].slice.call(cajon.querySelectorAll('[data-omj-linea]')); }
  function indiceDe(l) { return lineas().indexOf(l) + 1; }

  function estado(linea, texto, on) {
    var e = linea.querySelector('[data-omj-estado]');
    if (!e) return;
    e.textContent = texto;
    e.classList.toggle('on', !!on);
  }

  /* Tallas, colores o parejas talla/color sin stock (metacampo custom.agotados del producto, p. ej. «6XL, Morado,
     XL/Beige»; Shopify no lleva stock por talla y color de la braguita): no se pueden elegir y, si una prenda ya
     guardada lo tiene, cuenta como pendiente. */
  function norma(v) { return String(v || '').toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim(); }
  function marcarAgotados(linea) {
    var caja = linea.querySelector('[data-omj-agotados]');
    var lista = caja ? caja.getAttribute('data-omj-agotados').split(/[,\n;]/).map(norma).filter(Boolean) : [];
    if (!lista.length) return;
    function no(a, b) {
      a = norma(a); b = norma(b);
      return lista.indexOf(a) >= 0 || lista.indexOf(b) >= 0 || (!!a && !!b && (lista.indexOf(a + '/' + b) >= 0 || lista.indexOf(b + '/' + a) >= 0));
    }
    linea.querySelectorAll('.omj-uni').forEach(function (u) {
      var s = u.querySelectorAll('select');
      if (s.length < 2) return;
      [[s[0], s[1], true], [s[1], s[0], false]].forEach(function (p) {
        [].forEach.call(p[0].options, function (op) {
          if (!op.value) return;
          if (op.getAttribute('data-base') === null) op.setAttribute('data-base', op.textContent);
          var x = p[2] ? no(op.value, p[1].value) : no(p[1].value, op.value);
          op.disabled = x;
          op.textContent = op.getAttribute('data-base') + (x ? ' · Agotado' : '');
        });
      });
    });
  }
  function pendiente(s) { var op = s.options[s.selectedIndex]; return !s.value || !!(op && op.disabled); }

  function faltan(linea) {
    var n = 0;
    marcarAgotados(linea);
    linea.querySelectorAll('[data-omj-prop]').forEach(function (s) {
      var vacio = pendiente(s);
      s.classList.toggle('falta', vacio);
      if (vacio) n += 1;
    });
    var av = linea.querySelector('[data-omj-aviso]');
    if (av) av.hidden = n === 0;
    return n;
  }

  function revisarTodo() {
    var boton = cajon.querySelector('[data-omj-pagar]');
    var bloqueo = cajon.querySelector('[data-omj-bloqueo]');
    lineas().forEach(marcarAgotados);
    if (!boton) return;
    if (cajon.dataset.exigir !== 'true') return;
    var p = 0;
    lineas().forEach(function (l) { p += faltan(l); });
    /* El boton no se desactiva: al pulsarlo se explica que falta y se lleva el foco alli. */
    boton.setAttribute('aria-disabled', p > 0 ? 'true' : 'false');
    if (bloqueo) bloqueo.style.display = p > 0 ? 'block' : 'none';
  }

  var temps = {};

  cajon.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-omj-prop]');
    if (sel) {
      var linea = sel.closest('[data-omj-linea]');
      if (!linea) return;
      var idx = indiceDe(linea);
      var props = {};
      linea.querySelectorAll('[data-omj-prop]').forEach(function (s) { props[s.dataset.omjProp] = s.value || ''; });
      faltan(linea); revisarTodo();
      estado(linea, cajon.dataset.textoGuardando || 'Guardando...', true);
      clearTimeout(temps[idx]);
      /* /cart/change.js con propiedades y sin cantidad deja la línea en 1: se manda siempre la cantidad. */
      var cant = linea.querySelector('[data-omj-cantidad]');
      var q = cant ? parseInt(cant.value, 10) : NaN;
      var cuerpo = { line: idx, properties: props };
      if (isFinite(q) && q > 0) cuerpo.quantity = q;
      temps[idx] = setTimeout(function () {
        pedir('/cart/change.js', cuerpo).then(function () {
          estado(linea, cajon.dataset.textoGuardado || 'Guardado', true);
          setTimeout(function () { estado(linea, '', false); }, 2000);
        }).catch(function () {
          estado(linea, 'Sin guardar: vuelve a elegir', true);
        });
      }, 350);
      return;
    }

    var campo = e.target.closest('[data-omj-cantidad]');
    if (campo) {
      var l2 = campo.closest('[data-omj-linea]');
      var v = parseInt(campo.value, 10);
      if (!isFinite(v) || v < 1) v = 1;
      cambiar(l2, v);
    }
  });

  /* Propiedades de la línea recortadas a las prendas que quedan: al bajar de 2 packs de 2 a 1, las tallas de las
     prendas 3 y 4 no deben seguir en el pedido. */
  function propsPara(linea, cantidad) {
    var base = parseInt(linea.getAttribute('data-base'), 10) || 0;
    if (!base || cantidad < 1) return null;
    var tope = base * cantidad, props = {};
    linea.querySelectorAll('[data-omj-prop]').forEach(function (s) {
      var m = /^Unidad (\d+) · /.exec(s.dataset.omjProp);
      if (m && +m[1] <= tope) props[s.dataset.omjProp] = s.value || '';
    });
    return props;
  }

  function cambiar(linea, cantidad) {
    var idx = indiceDe(linea);
    if (idx < 1) return;
    var cuerpo = { line: idx, quantity: cantidad };
    var props = propsPara(linea, cantidad);
    if (props) cuerpo.properties = props;
    pedir('/cart/change.js', cuerpo)
      .then(function () { return refrescar(); })
      .catch(function (err) {
        return refrescar().then(function () {
          aviso((err && err.datos && err.datos.description) || 'No se ha podido cambiar la cantidad. Vuelve a intentarlo.');
        });
      });
  }

  cajon.addEventListener('click', function (e) {
    var menos = e.target.closest('[data-omj-menos]');
    var mas = e.target.closest('[data-omj-mas]');
    var quitar = e.target.closest('[data-omj-quitar]');
    var anadir = e.target.closest('[data-omj-anadir]');
    var mejora = e.target.closest('[data-om-mejora-btn]');

    if (mejora && window.omMejoraPack) {
      window.omMejoraPack(mejora.closest('[data-om-mejora]'), function (msj) {
        refrescar().then(function () { aviso(msj); });
      });
      return;
    }

    if (anadir) {
      var caja = anadir.closest('[data-omj-up]');
      var sel2 = caja ? caja.querySelector('[data-omj-variante]') : null;
      var id = sel2 ? sel2.value : anadir.dataset.omjAnadir;
      if (!id) return;
      anadir.disabled = true;
      pedir('/cart/add.js', { id: parseInt(id, 10), quantity: 1 })
        .then(refrescar)
        .catch(function () { anadir.disabled = false; });
      return;
    }

    var linea = e.target.closest('[data-omj-linea]');
    if (!linea) return;
    if (quitar) { cambiar(linea, 0); return; }
    if (menos || mas) {
      var campo = linea.querySelector('[data-omj-cantidad]');
      var v = parseInt(campo.value, 10) || 1;
      v = mas ? v + 1 : v - 1;
      if (v < 1) v = 1;
      campo.value = v;
      cambiar(linea, v);
    }
  });

  cajon.addEventListener('click', function (e) {
    var pagar = e.target.closest('[data-omj-pagar]');
    if (!pagar || cajon.dataset.exigir !== 'true') return;
    var primera = null;
    lineas().forEach(function (l) { if (faltan(l) > 0 && !primera) primera = l; });
    if (primera) {
      e.preventDefault();
      var bloqueo = cajon.querySelector('[data-omj-bloqueo]');
      if (bloqueo) bloqueo.style.display = 'block';
      primera.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var s = primera.querySelector('.falta');
      if (s) s.focus({ preventScroll: true });
    }
  });

  window.omCajonAbrir = abrir;
  window.omCajon = { abrir: abrir, cerrar: cerrar, refrescar: refrescar, aviso: aviso };

  pintarContador();
  revisarTodo();
})();